<template>
  <div v-if="!hideHeader" class="page-header">
    <div class="header-action header-left text-left">
      <slot name="left">
        <v-btn icon class="ml-6 focused" @click="onBackClick">
          <v-icon size="32" color="primary" class="header-icon">$mdiChevronLeft</v-icon>
        </v-btn>
      </slot>
    </div>
    <div class="flex-shrink-0" v-long-press="1000" @long-press-start="toggleVConsoleButton">{{ label }}</div>
    <div class="header-action header-right text-right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LogaHeader',
  data () {
    return {
      hideHeader: sessionStorage.getItem('hideHeader')
    }
  },
  props: {
    label: String
  },
  methods: {
    onBackClick () {
      // eslint-disable-next-line no-undef
      if (typeof (Android) !== 'undefined') Android.canGoBack() // will call window.backCallback later
      else {
        const currentPath = window.location.href
        this.$router.go(-1)
        setTimeout(() => {
          if (window.location.href === currentPath) this.$router.replace({ name: 'Card', params: { cardId: this.$route.params.cardId } })
        }, 200)
      }
    },
    toggleVConsoleButton () {
      const vcSwitch = document.querySelector('.vc-switch')
      if (vcSwitch) {
        if (vcSwitch.classList.contains('d-block')) vcSwitch.classList.remove('d-block')
        else vcSwitch.classList.add('d-block')
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/style/loga-header.scss';
</style>
